/* global FlowbiteInstances */
import { hideFlowbiteModal, initFlowbiteModal, showFlowbiteModal } from 'Scripts/initializeFlowBiteModals';

const MODAL_ID = 'approval-explanation-prompt';

export const EXPLANATION_MAX_LENGTH = 1000;

let explanationUrl = null;

let settle = null;

const buildModal = () => {
    const modal = document.createElement('div');
    modal.id = MODAL_ID;
    modal.tabIndex = -1;
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('aria-labelledby', `${MODAL_ID}-title`);
    modal.className = 'tw-hidden modal__box';
    modal.innerHTML = `
        <div class="modal__container">
            <div class="modal__inner-container">
                <div class="tw-mb-4 tw-flex tw-flex-row tw-items-center tw-justify-between tw-rounded-t">
                    <h3 id="${MODAL_ID}-title" class="tw-text-2xl tw-font-semibold tw-text-blue"></h3>
                </div>
                <div class="modal__form-container tw-flex tw-flex-col tw-gap-1.5">
                    <p class="modal__text js-explanation-prompt-message"></p>
                    <textarea id="${MODAL_ID}-field" class="tw-border-0 text-input" rows="4" maxlength="${EXPLANATION_MAX_LENGTH}"></textarea>
                    <div class="tw-flex tw-justify-between tw-gap-4 tw-text-xs">
                        <span class="js-explanation-prompt-error tw-text-red" role="alert"></span>
                        <span class="js-explanation-prompt-count tw-whitespace-nowrap tw-text-charcoal-50"></span>
                    </div>
                    <div class="modal__footer">
                        <button type="button" class="button secondary" data-modal-hide="${MODAL_ID}"></button>
                        <button type="button" class="button primary js-explanation-prompt-save"></button>
                    </div>
                </div>
            </div>
        </div>`;

    document.body.appendChild(modal);

    const field = modal.querySelector('textarea');
    const count = modal.querySelector('.js-explanation-prompt-count');
    const save = modal.querySelector('.js-explanation-prompt-save');
    const error = modal.querySelector('.js-explanation-prompt-error');

    field.setAttribute('aria-label', $t('Explanation'));
    modal.querySelector(`[data-modal-hide="${MODAL_ID}"]`).textContent = $t('Skip');
    save.textContent = $t('Save');

    field.addEventListener('input', () => {
        count.textContent = `${field.value.length} / ${EXPLANATION_MAX_LENGTH}`;
        save.disabled = field.value.trim() === '';
    });

    // Static: a stray click outside must not throw away a half-written explanation.
    initFlowbiteModal(MODAL_ID, null, { backdrop: 'static' });

    // Skip, Save and Esc all close through here. Esc goes through Flowbite's own
    // hide, which leaves the page's scroll lock behind.
    $(document).on('modalHidden', (event, modalId) => {
        if (modalId !== MODAL_ID) {
            return;
        }

        document.body.classList.remove('tw-overflow-hidden');

        if (settle) {
            settle();
        }
    });

    const close = () => hideFlowbiteModal(FlowbiteInstances.getInstance('Modal', MODAL_ID), MODAL_ID);

    save.addEventListener('click', () => {
        save.disabled = true;
        error.textContent = '';

        $.ajax({
            url: explanationUrl,
            type: 'POST',
            data: { explanation: field.value },
            headers: { Accept: 'application/json' },
        })
            .done(() => {
                close();
                window.showToast($t('Explanation added'), 'success');
            })
            .fail((xhr) => {
                const json = xhr.responseJSON || {};
                error.textContent = json.errors?.explanation?.[0] || json.error || json.message || xhr.statusText || $t('Something went wrong');
                save.disabled = field.value.trim() === '';
            });
    });

    return modal;
};

/**
 * After a change goes for approval, or is applied and recorded, offers the requester
 * the chance to explain it. Skip and Esc close it without a request. Resolves once
 * it closes.
 */
export const promptForApprovalExplanation = ({ url, reference, applied = false }) => {
    const modal = document.getElementById(MODAL_ID) ?? buildModal();
    const field = modal.querySelector('textarea');

    explanationUrl = url;
    modal.querySelector(`#${MODAL_ID}-title`).textContent = applied ? $t('Change recorded') : $t('Submitted for approval');
    // textContent, never markup: the message carries server-supplied text.
    modal.querySelector('.js-explanation-prompt-message').textContent = applied
        ? $t('Add an explanation (optional)')
        : $t('{{reference}} is waiting for approval. Add an explanation for the approver (optional).', { reference });
    modal.querySelector('.js-explanation-prompt-error').textContent = '';
    field.value = '';
    field.dispatchEvent(new Event('input'));

    return new Promise((resolve) => {
        settle = () => {
            settle = null;
            resolve();
        };

        showFlowbiteModal(FlowbiteInstances.getInstance('Modal', MODAL_ID), MODAL_ID);
        field.focus();
    });
};
